export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-1920w.9e84769f.avif";